// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--color-light);
}

.app-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: var(--color-light);
  border-bottom: 1px solid var(--gray-300);
  min-height: 70px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  gap: 24px;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  width: calc(30% - 30px);
  min-width: 300px;
}

.header-logo {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-logo img {
  height: 44px;
  transform: skewX(-8deg);
}
.header-logo .company-name {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  font-weight: 800;
  font-size: 15px;
  color: var(--color-primary);
}

.brand-divider {
  width: 1px;
  height: 26px;
  background: var(--gray-200);
}

.nav-arrows {
  display: flex;
  gap: 2px;
}

.nav-arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  border-radius: 5px;
  color: var(--gray-500);
}
.nav-arrow-btn:hover {
  color: var(--gray-700);
  background: var(--gray-100);
}

.header-mobile-actions {
  display: none;
}

.header-nav {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
}

.header-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--gray-700);
  white-space: nowrap;
  position: relative;
}
.header-link:hover {
  color: var(--color-primary);
  background: var(--gray-100);
}
.header-link.active {
  color: var(--color-primary);
  font-weight: 700;
}
.header-link.active::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: -15px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--color-primary);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-cta {
  margin-right: 8px;
  padding: 8px 14px;
}

.icon-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  color: var(--gray-700);
}
.icon-btn:hover, .icon-btn.active {
  background: var(--gray-100);
  color: var(--color-primary);
}
.icon-btn .icon-btn-label {
  display: none;
}

.notif-dot {
  position: absolute;
  top: 7px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-danger);
  border: 1.5px solid #fff;
}

.account-menu {
  position: relative;
  margin-left: 4px;
}

.account-trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  padding: 4px;
  border-radius: 20px;
  color: var(--gray-500);
}
.account-trigger img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.account-trigger:hover {
  background: var(--gray-100);
}

.account-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  width: 240px;
  background: #fff;
  border: 1px solid var(--gray-200);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 30;
}
.account-dropdown .account-head {
  padding: 10px 12px;
  border-bottom: 1px solid var(--gray-100);
  margin-bottom: 4px;
}
.account-dropdown .account-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-900);
  background: transparent;
  border: none;
  text-align: left;
}
.account-dropdown .account-item:hover {
  background: var(--gray-100);
}
.account-dropdown .account-item.logout {
  color: var(--color-danger);
}

.app-body {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  padding: 0 30px;
  width: 100%;
}
.app-body.full-width .app-content {
  padding-left: 0;
}

.app-content {
  flex: 1 1;
  min-width: 0;
  padding: 24px 0 40px 28px;
}

.buyer-sidebar {
  width: 30%;
  min-width: 300px;
  max-width: 400px;
  flex-shrink: 0;
  padding: 20px 20px 20px 0;
  border-right: 1px solid var(--gray-300);
  align-self: stretch;
}
.buyer-sidebar .side-card {
  border: 1px solid var(--gray-200);
  border-radius: 14px;
  margin-bottom: 20px;
}
.buyer-sidebar .side-title {
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 6px;
}
.buyer-sidebar .side-title.small {
  font-size: 15px;
  margin: 0;
}
.buyer-sidebar .side-group {
  margin-bottom: 20px;
}

.clock-card {
  padding: 14px 16px;
}
.clock-card .clock-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.clock-card .clock-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
}
.clock-card .clock-date {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--gray-500);
  letter-spacing: 0.03em;
}
.clock-card .clock-time {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-primary);
}
.clock-card .oil-headline {
  display: block;
  margin-top: 12px;
  padding: 0;
  background: none;
  border: none;
  text-align: left;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.3;
  color: var(--color-primary);
}
.clock-card .oil-headline:hover {
  text-decoration: underline;
}

.stat-row {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 11px 0;
  background: none;
  border: none;
  border-top: 1px solid var(--gray-100);
  text-align: left;
}
.stat-row:first-child {
  border-top: none;
}
.stat-row:hover .stat-icon {
  background: #e9ecef;
}
.stat-row:hover .stat-label {
  color: #000;
  font-weight: 600;
}
.stat-row:hover .stat-chev {
  color: #111;
  transform: translateX(3px);
}
.stat-row .stat-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 9px;
  background: var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
}
.stat-row .stat-num {
  font-size: 28px;
  font-weight: 800;
  color: var(--color-primary);
  min-width: 40px;
  text-align: right;
}
.stat-row .stat-label {
  flex: 1 1;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gray-900);
}
.stat-row .stat-chev {
  color: var(--gray-500);
  display: flex;
  transition: transform 0.15s ease;
}

.news-card {
  padding: 16px 0;
}
.news-card .news-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 12px;
}
.news-card .news-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 0 16px 6px;
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;
}
.news-card .news-item {
  scroll-snap-align: start;
  flex: 0 0 240px;
  display: flex;
  gap: 12px;
  padding: 0;
  background: none;
  border: none;
  text-align: left;
}
.news-card .news-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.news-card .news-title {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--color-primary);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news-card .news-meta {
  font-size: 11px;
  color: var(--gray-500);
  margin-top: 4px;
}

.news-thumb {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #e7c78a 0%, #c96b3e 55%, #6b2f1a 100%);
}
.news-thumb.thumb-1 {
  background: linear-gradient(135deg, #9fd0e6 0%, #3f7ea6 55%, #12293a 100%);
}
.news-thumb.thumb-2 {
  background: linear-gradient(135deg, #c9d98a 0%, #7f9a3a 55%, #26311a 100%);
}

.crude-grid {
  display: flex;
  gap: 12px;
}

.crude-card {
  flex: 1 1;
  min-width: 0;
  display: block;
  border: 1px solid var(--gray-200);
  border-radius: 14px;
  padding: 12px 12px 8px;
  color: var(--color-primary);
}
.crude-card:hover {
  border-color: var(--gray-300);
  background: #fcfcfd;
}
.crude-card .crude-name {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--gray-500);
}
.crude-card .crude-price {
  font-size: 20px;
  font-weight: 800;
  margin-top: 2px;
}
.crude-card .crude-change {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 11.5px;
  font-weight: 700;
}
.crude-card .crude-change.up {
  color: var(--color-success);
}
.crude-card .crude-change.down {
  color: var(--color-danger);
}
.crude-card .crude-chart {
  margin-top: 6px;
}
.crude-card .crude-sample {
  font-size: 10px;
  color: var(--gray-500);
  text-align: right;
}

.app-footer {
  padding: 18px 30px 22px;
  border-top: 1px solid var(--gray-200);
}
.app-footer p {
  margin: 0;
  font-size: 11.5px;
  color: var(--gray-500);
}
.app-footer a {
  color: var(--gray-500);
  text-decoration: underline;
}
.app-footer a:hover {
  color: var(--gray-700);
}

@media (max-width: 1280px) {
  .header-link span {
    display: none;
  }
  .header-link.active::after {
    left: 8px;
    right: 8px;
  }
}
@media (max-width: 1100px) {
  .buyer-sidebar {
    display: none;
  }
  .app-content {
    padding-left: 0;
  }
  .header-brand {
    width: auto;
    min-width: 0;
  }
}
@media (max-width: 768px) {
  .app-header {
    min-height: 56px;
    padding: 0 16px;
    padding-top: env(safe-area-inset-top);
    gap: 8px;
  }
  .header-brand {
    gap: 10px;
  }
  .header-brand .brand-divider,
  .header-brand .nav-arrows {
    display: none;
  }
  .header-logo {
    gap: 10px;
  }
  .header-logo img {
    height: 32px;
  }
  .header-logo .company-name {
    font-size: 13px;
  }
  .header-nav {
    display: none;
  }
  .header-mobile-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }
  .header-mobile-actions .account-trigger img {
    width: 30px;
    height: 30px;
  }
  .app-body {
    padding: 0 16px;
  }
  .app-content {
    padding: 16px 0 calc(64px + 24px + env(safe-area-inset-bottom));
  }
  .app-footer {
    display: none;
  }
}
.mobile-tabbar {
  display: none;
}

@media (max-width: 768px) {
  .mobile-tabbar {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    height: calc(64px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(12px);
    border-top: 1px solid var(--gray-200);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.04);
  }
  .tab-item,
  .tab-fab {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    font-size: 11px;
    font-weight: 600;
    color: var(--gray-500);
    background: none;
    border: none;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
  }
  .tab-item.active,
  .tab-fab.active {
    color: var(--color-primary);
  }
  .tab-item:active,
  .tab-fab:active {
    transform: scale(0.94);
  }
  .tab-item {
    min-width: 0;
    white-space: nowrap;
  }
  .tab-item.active svg {
    color: var(--color-primary);
  }
  .tab-fab {
    color: var(--color-primary);
    justify-content: flex-end;
    padding-bottom: 8px;
  }
  .tab-fab .tab-fab-btn {
    width: 52px;
    height: 52px;
    margin-top: -26px;
    border-radius: 50%;
    background: var(--color-accent);
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 4px solid #fff;
    box-shadow: 0 6px 16px rgba(76, 107, 13, 0.35);
  }
  .tab-dot {
    position: absolute;
    top: -2px;
    right: -4px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-danger);
    border: 1.5px solid #fff;
  }
}
@media (max-width: 768px) {
  .app-body.full-width .app-content {
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
  }
}
@media (max-width: 380px) {
  .mobile-tabbar .tab-item {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/AppLayout.scss"],"names":[],"mappings":"AACA;EACC,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAAD;;AAIA;EACC,gBAAA;EACA,MAAA;EACA,WAAA;EACA,8BAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EAEA,uBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAFD;AAIC;EACC,YAAA;EACA,uBAAA;AAFF;AAKC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAHF;;AAOA;EACC,UAAA;EACA,YAAA;EACA,2BAAA;AAJD;;AAOA;EACC,aAAA;EACA,QAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAJD;AAMC;EACC,sBAAA;EACA,2BAAA;AAJF;;AAQA;EACC,aAAA;AALD;;AAQA;EACC,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;AALD;;AAQA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AALD;;AAQA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AALD;AAOC;EACC,2BAAA;EACA,2BAAA;AALF;AAQC;EACC,2BAAA;EACA,gBAAA;AANF;AAQE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,gCAAA;AANH;;AAWA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AARD;;AAWA;EACC,iBAAA;EACA,iBAAA;AARD;;AAWA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AARD;AAUC;EAEC,2BAAA;EACA,2BAAA;AATF;AAYC;EACC,aAAA;AAVF;;AAcA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,wBAAA;AAXD;;AAcA;EACC,kBAAA;EACA,gBAAA;AAXD;;AAcA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAXD;AAaC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAXF;AAcC;EACC,2BAAA;AAZF;;AAgBA;EACC,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;AAbD;AAeC;EACC,kBAAA;EACA,wCAAA;EACA,kBAAA;AAbF;AAgBC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAdF;AAgBE;EACC,2BAAA;AAdH;AAiBE;EACC,0BAAA;AAfH;;AAqBA;EACC,SAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAlBD;AAoBC;EACC,eAAA;AAlBF;;AAsBA;EACC,SAAA;EACA,YAAA;EACA,yBAAA;AAnBD;;AAuBA;EACC,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,uCAAA;EACA,mBAAA;AApBD;AAsBC;EACC,iCAAA;EACA,mBAAA;EACA,mBAAA;AApBF;AAuBC;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;AArBF;AAuBE;EACC,eAAA;EACA,SAAA;AArBH;AAyBC;EACC,mBAAA;AAvBF;;AA2BA;EACC,kBAAA;AAxBD;AA0BC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAxBF;AA2BC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAzBF;AA4BC;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AA1BF;AA6BC;EACC,eAAA;EACA,gBAAA;EACA,2BAAA;AA3BF;AA8BC;EACC,cAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;AA5BF;AA8BE;EACC,0BAAA;AA5BH;;AAiCA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,gBAAA;AA9BD;AAgCC;EACC,gBAAA;AA9BF;AAkCE;EACC,mBAAA;AAhCH;AAkCE;EACC,WAAA;EACA,gBAAA;AAhCH;AAkCE;EACC,WAAA;EACA,0BAAA;AAhCH;AAoCC;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAlCF;AAqCC;EACC,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AAnCF;AAsCC;EACC,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AApCF;AAuCC;EACC,sBAAA;EACA,aAAA;EACA,gCAAA;AArCF;;AAyCA;EACC,eAAA;AAtCD;AAwCC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AAtCF;AAyCC;EACC,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;AAvCF;AA0CC;EACC,wBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAxCF;AA2CC;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAzCF;AA4CC;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AA1CF;AA6CC;EACC,eAAA;EACA,sBAAA;EACA,eAAA;AA3CF;;AA+CA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,0EAAA;AA5CD;AA8CC;EACC,0EAAA;AA5CF;AA8CC;EACC,0EAAA;AA5CF;;AAgDA;EACC,aAAA;EACA,SAAA;AA7CD;;AAgDA;EACC,SAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;AA7CD;AA+CC;EACC,6BAAA;EACA,mBAAA;AA7CF;AAgDC;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AA9CF;AAiDC;EACC,eAAA;EACA,gBAAA;EACA,eAAA;AA/CF;AAkDC;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAhDF;AAkDE;EACC,2BAAA;AAhDH;AAkDE;EACC,0BAAA;AAhDH;AAoDC;EACC,eAAA;AAlDF;AAqDC;EACC,eAAA;EACA,sBAAA;EACA,iBAAA;AAnDF;;AAwDA;EACC,uBAAA;EACA,qCAAA;AArDD;AAuDC;EACC,SAAA;EACA,iBAAA;EACA,sBAAA;AArDF;AAwDC;EACC,sBAAA;EACA,0BAAA;AAtDF;AAwDE;EACC,sBAAA;AAtDH;;AA6DA;EACC;IACC,aAAA;EA1DA;EA4DD;IACC,SAAA;IACA,UAAA;EA1DA;AACF;AA6DA;EACC;IACC,aAAA;EA3DA;EA6DD;IACC,eAAA;EA3DA;EA6DD;IACC,WAAA;IACA,YAAA;EA3DA;AACF;AAiEA;EACC;IACC,gBAAA;IACA,eAAA;IACA,qCAAA;IACA,QAAA;EA/DA;EAkED;IACC,SAAA;EAhEA;EAkEA;;IAEC,aAAA;EAhED;EAoED;IACC,SAAA;EAlEA;EAoEA;IACC,YAAA;EAlED;EAqEA;IACC,eAAA;EAnED;EAuED;IACC,aAAA;EArEA;EAwED;IACC,aAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;EAtEA;EAwEA;IACC,WAAA;IACA,YAAA;EAtED;EA0ED;IACC,eAAA;EAxEA;EA2ED;IACC,+DAAA;EAzEA;EA4ED;IACC,aAAA;EA1EA;AACF;AA8EA;EACC,aAAA;AA5ED;;AA+EA;EACC;IACC,aAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,gDAAA;IACA,2CAAA;IACA,qCAAA;IACA,2BAAA;IACA,qCAAA;IACA,2CAAA;EA5EA;EA+ED;;IAEC,SAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,gBAAA;IACA,YAAA;IACA,UAAA;IACA,wCAAA;EA7EA;EA+EA;;IACC,2BAAA;EA5ED;EA+EA;;IACC,sBAAA;EA5ED;EAgFD;IACC,YAAA;IACA,mBAAA;EA9EA;EAiFD;IACC,2BAAA;EA/EA;EAkFD;IACC,2BAAA;IACA,yBAAA;IACA,mBAAA;EAhFA;EAkFA;IACC,WAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,+BAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,sBAAA;IACA,8CAAA;EAhFD;EAoFD;IACC,kBAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;IACA,+BAAA;IACA,wBAAA;EAlFA;AACF;AAqFA;EACC;IACC,wDAAA;EAnFA;AACF;AAsFA;EACC;IACC,eAAA;EApFA;AACF","sourcesContent":["// Layout mirrors ordrx_frontend: Header.scss, SideBar.scss, Dashboard.scss, Footer.scss\n.app-shell {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: var(--color-light);\n}\n\n// ---------- Header ----------\n.app-header {\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 20;\n\tbackground: var(--color-light);\n\tborder-bottom: 1px solid var(--gray-300);\n\tmin-height: 70px;\n\tpadding: 0 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 24px;\n}\n\n.header-brand {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n\tflex-shrink: 0;\n\t// lines the nav up with the content column, like Seller Central\n\twidth: calc(30% - 30px);\n\tmin-width: 300px;\n}\n\n.header-logo {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n\n\timg {\n\t\theight: 44px;\n\t\ttransform: skewX(-8deg);\n\t}\n\n\t.company-name {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tline-height: 1.1;\n\t\tfont-weight: 800;\n\t\tfont-size: 15px;\n\t\tcolor: var(--color-primary);\n\t}\n}\n\n.brand-divider {\n\twidth: 1px;\n\theight: 26px;\n\tbackground: var(--gray-200);\n}\n\n.nav-arrows {\n\tdisplay: flex;\n\tgap: 2px;\n}\n\n.nav-arrow-btn {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tbackground: transparent;\n\tborder: none;\n\tborder-radius: 5px;\n\tcolor: var(--gray-500);\n\n\t&:hover {\n\t\tcolor: var(--gray-700);\n\t\tbackground: var(--gray-100);\n\t}\n}\n\n.header-mobile-actions {\n\tdisplay: none;\n}\n\n.header-nav {\n\tflex: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n\tmin-width: 0;\n}\n\n.header-links {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n.header-link {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tpadding: 8px 12px;\n\tborder-radius: 8px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: var(--gray-700);\n\twhite-space: nowrap;\n\tposition: relative;\n\n\t&:hover {\n\t\tcolor: var(--color-primary);\n\t\tbackground: var(--gray-100);\n\t}\n\n\t&.active {\n\t\tcolor: var(--color-primary);\n\t\tfont-weight: 700;\n\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 12px;\n\t\t\tright: 12px;\n\t\t\tbottom: -15px;\n\t\t\theight: 3px;\n\t\t\tborder-radius: 3px 3px 0 0;\n\t\t\tbackground: var(--color-primary);\n\t\t}\n\t}\n}\n\n.header-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n}\n\n.header-cta {\n\tmargin-right: 8px;\n\tpadding: 8px 14px;\n}\n\n.icon-btn {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 38px;\n\theight: 38px;\n\tborder-radius: 8px;\n\tcolor: var(--gray-700);\n\n\t&:hover,\n\t&.active {\n\t\tbackground: var(--gray-100);\n\t\tcolor: var(--color-primary);\n\t}\n\n\t.icon-btn-label {\n\t\tdisplay: none;\n\t}\n}\n\n.notif-dot {\n\tposition: absolute;\n\ttop: 7px;\n\tright: 8px;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 50%;\n\tbackground: var(--color-danger);\n\tborder: 1.5px solid #fff;\n}\n\n.account-menu {\n\tposition: relative;\n\tmargin-left: 4px;\n}\n\n.account-trigger {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 4px;\n\tborder-radius: 20px;\n\tcolor: var(--gray-500);\n\n\timg {\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tborder-radius: 50%;\n\t\tobject-fit: cover;\n\t}\n\n\t&:hover {\n\t\tbackground: var(--gray-100);\n\t}\n}\n\n.account-dropdown {\n\tposition: absolute;\n\tright: 0;\n\ttop: calc(100% + 8px);\n\twidth: 240px;\n\tbackground: #fff;\n\tborder: 1px solid var(--gray-200);\n\tborder-radius: 12px;\n\tbox-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n\tpadding: 6px;\n\tz-index: 30;\n\n\t.account-head {\n\t\tpadding: 10px 12px;\n\t\tborder-bottom: 1px solid var(--gray-100);\n\t\tmargin-bottom: 4px;\n\t}\n\n\t.account-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\twidth: 100%;\n\t\tpadding: 9px 12px;\n\t\tborder-radius: 8px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tcolor: var(--gray-900);\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\ttext-align: left;\n\n\t\t&:hover {\n\t\t\tbackground: var(--gray-100);\n\t\t}\n\n\t\t&.logout {\n\t\t\tcolor: var(--color-danger);\n\t\t}\n\t}\n}\n\n// ---------- Body ----------\n.app-body {\n\tflex: 1;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tpadding: 0 30px;\n\twidth: 100%;\n\n\t&.full-width .app-content {\n\t\tpadding-left: 0;\n\t}\n}\n\n.app-content {\n\tflex: 1;\n\tmin-width: 0;\n\tpadding: 24px 0 40px 28px;\n}\n\n// ---------- Sidebar ----------\n.buyer-sidebar {\n\twidth: 30%;\n\tmin-width: 300px;\n\tmax-width: 400px;\n\tflex-shrink: 0;\n\tpadding: 20px 20px 20px 0;\n\tborder-right: 1px solid var(--gray-300);\n\talign-self: stretch;\n\n\t.side-card {\n\t\tborder: 1px solid var(--gray-200);\n\t\tborder-radius: 14px;\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.side-title {\n\t\tfont-size: 22px;\n\t\tline-height: 1.3;\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t\tmargin-bottom: 6px;\n\n\t\t&.small {\n\t\t\tfont-size: 15px;\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t.side-group {\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n.clock-card {\n\tpadding: 14px 16px;\n\n\t.clock-row {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t}\n\n\t.clock-icon {\n\t\twidth: 34px;\n\t\theight: 34px;\n\t\tborder-radius: 9px;\n\t\tbackground: var(--color-accent);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: #000;\n\t}\n\n\t.clock-date {\n\t\tfont-size: 11px;\n\t\tfont-weight: 600;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--gray-500);\n\t\tletter-spacing: 0.03em;\n\t}\n\n\t.clock-time {\n\t\tfont-size: 14px;\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t}\n\n\t.oil-headline {\n\t\tdisplay: block;\n\t\tmargin-top: 12px;\n\t\tpadding: 0;\n\t\tbackground: none;\n\t\tborder: none;\n\t\ttext-align: left;\n\t\tfont-size: 16px;\n\t\tfont-weight: 800;\n\t\tline-height: 1.3;\n\t\tcolor: var(--color-primary);\n\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n}\n\n.stat-row {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n\twidth: 100%;\n\tpadding: 11px 0;\n\tbackground: none;\n\tborder: none;\n\tborder-top: 1px solid var(--gray-100);\n\ttext-align: left;\n\n\t&:first-child {\n\t\tborder-top: none;\n\t}\n\n\t&:hover {\n\t\t.stat-icon {\n\t\t\tbackground: #e9ecef;\n\t\t}\n\t\t.stat-label {\n\t\t\tcolor: #000;\n\t\t\tfont-weight: 600;\n\t\t}\n\t\t.stat-chev {\n\t\t\tcolor: #111;\n\t\t\ttransform: translateX(3px);\n\t\t}\n\t}\n\n\t.stat-icon {\n\t\twidth: 38px;\n\t\theight: 38px;\n\t\tflex-shrink: 0;\n\t\tborder-radius: 9px;\n\t\tbackground: var(--gray-100);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: var(--color-primary);\n\t}\n\n\t.stat-num {\n\t\tfont-size: 28px;\n\t\tfont-weight: 800;\n\t\tcolor: var(--color-primary);\n\t\tmin-width: 40px;\n\t\ttext-align: right;\n\t}\n\n\t.stat-label {\n\t\tflex: 1;\n\t\tfont-size: 13.5px;\n\t\tfont-weight: 500;\n\t\tcolor: var(--gray-900);\n\t}\n\n\t.stat-chev {\n\t\tcolor: var(--gray-500);\n\t\tdisplay: flex;\n\t\ttransition: transform 0.15s ease;\n\t}\n}\n\n.news-card {\n\tpadding: 16px 0;\n\n\t.news-head {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 0 16px 12px;\n\t}\n\n\t.news-scroll {\n\t\tdisplay: flex;\n\t\tgap: 12px;\n\t\toverflow-x: auto;\n\t\tpadding: 0 16px 6px;\n\t\tscroll-snap-type: x mandatory;\n\t\tscrollbar-width: thin;\n\t}\n\n\t.news-item {\n\t\tscroll-snap-align: start;\n\t\tflex: 0 0 240px;\n\t\tdisplay: flex;\n\t\tgap: 12px;\n\t\tpadding: 0;\n\t\tbackground: none;\n\t\tborder: none;\n\t\ttext-align: left;\n\t}\n\n\t.news-copy {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmin-width: 0;\n\t}\n\n\t.news-title {\n\t\tfont-size: 13px;\n\t\tfont-weight: 700;\n\t\tline-height: 1.3;\n\t\tcolor: var(--color-primary);\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t}\n\n\t.news-meta {\n\t\tfont-size: 11px;\n\t\tcolor: var(--gray-500);\n\t\tmargin-top: 4px;\n\t}\n}\n\n.news-thumb {\n\twidth: 56px;\n\theight: 56px;\n\tborder-radius: 8px;\n\tflex-shrink: 0;\n\tbackground: linear-gradient(135deg, #e7c78a 0%, #c96b3e 55%, #6b2f1a 100%);\n\n\t&.thumb-1 {\n\t\tbackground: linear-gradient(135deg, #9fd0e6 0%, #3f7ea6 55%, #12293a 100%);\n\t}\n\t&.thumb-2 {\n\t\tbackground: linear-gradient(135deg, #c9d98a 0%, #7f9a3a 55%, #26311a 100%);\n\t}\n}\n\n.crude-grid {\n\tdisplay: flex;\n\tgap: 12px;\n}\n\n.crude-card {\n\tflex: 1;\n\tmin-width: 0;\n\tdisplay: block;\n\tborder: 1px solid var(--gray-200);\n\tborder-radius: 14px;\n\tpadding: 12px 12px 8px;\n\tcolor: var(--color-primary);\n\n\t&:hover {\n\t\tborder-color: var(--gray-300);\n\t\tbackground: #fcfcfd;\n\t}\n\n\t.crude-name {\n\t\tfont-size: 11px;\n\t\tfont-weight: 700;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 0.04em;\n\t\tcolor: var(--gray-500);\n\t}\n\n\t.crude-price {\n\t\tfont-size: 20px;\n\t\tfont-weight: 800;\n\t\tmargin-top: 2px;\n\t}\n\n\t.crude-change {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 2px;\n\t\tfont-size: 11.5px;\n\t\tfont-weight: 700;\n\n\t\t&.up {\n\t\t\tcolor: var(--color-success);\n\t\t}\n\t\t&.down {\n\t\t\tcolor: var(--color-danger);\n\t\t}\n\t}\n\n\t.crude-chart {\n\t\tmargin-top: 6px;\n\t}\n\n\t.crude-sample {\n\t\tfont-size: 10px;\n\t\tcolor: var(--gray-500);\n\t\ttext-align: right;\n\t}\n}\n\n// ---------- Footer ----------\n.app-footer {\n\tpadding: 18px 30px 22px;\n\tborder-top: 1px solid var(--gray-200);\n\n\tp {\n\t\tmargin: 0;\n\t\tfont-size: 11.5px;\n\t\tcolor: var(--gray-500);\n\t}\n\n\ta {\n\t\tcolor: var(--gray-500);\n\t\ttext-decoration: underline;\n\n\t\t&:hover {\n\t\t\tcolor: var(--gray-700);\n\t\t}\n\t}\n}\n\n// ---------- Responsive ----------\n// Tablet: drop the sidebar, then the link labels.\n@media (max-width: 1280px) {\n\t.header-link span {\n\t\tdisplay: none;\n\t}\n\t.header-link.active::after {\n\t\tleft: 8px;\n\t\tright: 8px;\n\t}\n}\n\n@media (max-width: 1100px) {\n\t.buyer-sidebar {\n\t\tdisplay: none;\n\t}\n\t.app-content {\n\t\tpadding-left: 0;\n\t}\n\t.header-brand {\n\t\twidth: auto;\n\t\tmin-width: 0;\n\t}\n}\n\n// Phone: native-app chrome — compact top app bar + bottom tab bar.\n$tabbar-h: 64px;\n\n@media (max-width: 768px) {\n\t.app-header {\n\t\tmin-height: 56px;\n\t\tpadding: 0 16px;\n\t\tpadding-top: env(safe-area-inset-top);\n\t\tgap: 8px;\n\t}\n\n\t.header-brand {\n\t\tgap: 10px;\n\n\t\t.brand-divider,\n\t\t.nav-arrows {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.header-logo {\n\t\tgap: 10px;\n\n\t\timg {\n\t\t\theight: 32px;\n\t\t}\n\n\t\t.company-name {\n\t\t\tfont-size: 13px;\n\t\t}\n\t}\n\n\t.header-nav {\n\t\tdisplay: none;\n\t}\n\n\t.header-mobile-actions {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tmargin-left: auto;\n\n\t\t.account-trigger img {\n\t\t\twidth: 30px;\n\t\t\theight: 30px;\n\t\t}\n\t}\n\n\t.app-body {\n\t\tpadding: 0 16px;\n\t}\n\n\t.app-content {\n\t\tpadding: 16px 0 calc(#{$tabbar-h} + 24px + env(safe-area-inset-bottom));\n\t}\n\n\t.app-footer {\n\t\tdisplay: none;\n\t}\n}\n\n// ---------- Bottom tab bar ----------\n.mobile-tabbar {\n\tdisplay: none;\n}\n\n@media (max-width: 768px) {\n\t.mobile-tabbar {\n\t\tdisplay: flex;\n\t\tposition: fixed;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: 40;\n\t\theight: calc(#{$tabbar-h} + env(safe-area-inset-bottom));\n\t\tpadding-bottom: env(safe-area-inset-bottom);\n\t\tbackground: rgba(255, 255, 255, 0.96);\n\t\tbackdrop-filter: blur(12px);\n\t\tborder-top: 1px solid var(--gray-200);\n\t\tbox-shadow: 0 -4px 20px rgba(0, 0, 0, 0.04);\n\t}\n\n\t.tab-item,\n\t.tab-fab {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 3px;\n\t\tfont-size: 11px;\n\t\tfont-weight: 600;\n\t\tcolor: var(--gray-500);\n\t\tbackground: none;\n\t\tborder: none;\n\t\tpadding: 0;\n\t\t-webkit-tap-highlight-color: transparent;\n\n\t\t&.active {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&:active {\n\t\t\ttransform: scale(0.94);\n\t\t}\n\t}\n\n\t.tab-item {\n\t\tmin-width: 0;\n\t\twhite-space: nowrap;\n\t}\n\n\t.tab-item.active svg {\n\t\tcolor: var(--color-primary);\n\t}\n\n\t.tab-fab {\n\t\tcolor: var(--color-primary);\n\t\tjustify-content: flex-end;\n\t\tpadding-bottom: 8px;\n\n\t\t.tab-fab-btn {\n\t\t\twidth: 52px;\n\t\t\theight: 52px;\n\t\t\tmargin-top: -26px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: var(--color-accent);\n\t\t\tcolor: #000;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder: 4px solid #fff;\n\t\t\tbox-shadow: 0 6px 16px rgba(76, 107, 13, 0.35);\n\t\t}\n\t}\n\n\t.tab-dot {\n\t\tposition: absolute;\n\t\ttop: -2px;\n\t\tright: -4px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 50%;\n\t\tbackground: var(--color-danger);\n\t\tborder: 1.5px solid #fff;\n\t}\n}\n\n@media (max-width: 768px) {\n\t.app-body.full-width .app-content {\n\t\tpadding-bottom: calc(#{$tabbar-h} + env(safe-area-inset-bottom));\n\t}\n}\n\n@media (max-width: 380px) {\n\t.mobile-tabbar .tab-item {\n\t\tfont-size: 10px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
